import React from 'react'
import { observer } from 'mobx-react'
import { Modal } from 'react-bootstrap'
import { capitalizeFirstLetters } from 'src/deps'
import { i18nTranslate, currencyFormat, isINMarket } from 'src/utils'
import { multipleSubscriptionContainer, cartContainer } from 'src/models'
import { SubscriptionModalProductDetails } from './SubscriptionModalProductDetails'
import { SubscriptionAgreementSection } from './SubscriptionAgreementSection'
import './styles.scss'
import { overlayState } from 'src/views/components/Overlay'
import { AuthorizedSubscriptionLimitInfo } from 'src/views/components/MultipleSubscriptionCart/AuthorizedSubscriptionLimit/AuthorizedSubscriptionLimitInfo'

@observer
class AddToExistingSubscriptionModal extends React.Component {
  componentDidMount() {
    this.init()
  }

  init = () => {
    const { selectedSubscriptionGroup = {} } = this.props
    multipleSubscriptionContainer.getSelectedSubscriptionDetails(
      selectedSubscriptionGroup
    )
  }

  handleAddCartItemsToSubscription = async emandateCallback => {
    const {
      cartSubscriptionItems = [],
      selectedSubscriptionGroup = '',
      handleAddToSubscription,
    } = this.props

    await handleAddToSubscription(
      {
        subscriptionItemId: selectedSubscriptionGroup,
        cartItemDetails: cartSubscriptionItems,
      },
      emandateCallback
    )
  }

  handleItemQuantityChange = async (count = 0, itemId = 0) => {
    await multipleSubscriptionContainer.updateItemQuantityInCart({
      cartItemId: itemId,
      quantity: count,
    })
    overlayState.hideLoader()
  }

  handleItemFrequencyChange = async (
    count = 0,
    itemId = 0,
    subscription = {}
  ) => {
    const response =
      await multipleSubscriptionContainer.updateItemFrequencyInCart({
        cartItemId: itemId,
        quantity: count,
        subscription: subscription,
      })

    return multipleSubscriptionContainer.isSuccessResponse(response)
  }

  renderSubscriptionProductDetails = () => {
    const { cartSubscriptionItems = [] } = this.props
    return (
      <SubscriptionModalProductDetails
        cartSubscriptionList={cartSubscriptionItems}
        handleItemQuantityChange={this.handleItemQuantityChange}
        handleItemFrequencyChange={this.handleItemFrequencyChange}
      />
    )
  }

  renderSubTotal = () => {
    const subscriptionSubTotal =
      cartContainer.cartResponse?.properties?.subsctiptionItemsTotal || 0

    const subTotal = currencyFormat({ price: subscriptionSubTotal })

    const subTotalTitle = i18nTranslate(
      'cartCreateNewSubscriptionComponent.addToSubscription.combinedSubtotalText',
      'Combined Subtotal: %currency_symbol%%price%',
      { isNextGenTranslations: true }
    ).replace('%currency_symbol%%price%', subTotal)

    return (
      <div
        className="subscription-sub-total-wrapper"
        data-testid="qa-subscription-sub-total">
        <span>{subTotalTitle}</span>
      </div>
    )
  }

  renderAgreementInfo = () => {
    const { cartSubscriptionItems = [] } = this.props
    const subscriptionItemsCountInCart = cartSubscriptionItems.length || 0

    return (
      <div className="subscription-agreements-wrapper">
        <SubscriptionAgreementSection
          handleAddToSubscription={this.handleAddCartItemsToSubscription}
          subscriptionItemsCountInCart={subscriptionItemsCountInCart}
          cartSubscriptionItems={cartSubscriptionItems}
        />
      </div>
    )
  }

  renderAuthorizationLimitInfo = () => {
    const authorizedLimit = Number(
      multipleSubscriptionContainer.getMaxGrandTotalFromResponse()
    )
    const existingSubscriptionGrandTotal = Number(
      multipleSubscriptionContainer.getSelectedSubscriptionGrandTotal()
    )
    const subscriptionSubTotal = Number(
      cartContainer.cartResponse?.properties?.subsctiptionItemsTotal || 0
    )
    const isLimitBreached =
      authorizedLimit > 0 &&
      existingSubscriptionGrandTotal + subscriptionSubTotal > authorizedLimit

    // If condition not met, hide this section
    if (!isINMarket() || !isLimitBreached) {
      return null
    }
    return <AuthorizedSubscriptionLimitInfo />
  }

  render() {
    const { handleAddToSubscriptionModalClose, showModal = false } = this.props
    const { cartSubscriptionItems = [] } = this.props
    const itemCount = cartSubscriptionItems?.length || 0
    const subscriptionName =
      multipleSubscriptionContainer?.selectedSubscriptionGroupDetails?.name ||
      ''

    const modifiedSubscriptionName = capitalizeFirstLetters(subscriptionName)
    const addThisItemToSubscription = i18nTranslate(
      'cartCreateNewSubscriptionComponent.addToSubscription.addThisItemToSubscription_',
      'Add this item to %%subscription_name%%?',
      { isNextGenTranslations: true }
    ).replace('%%subscription_name%%', modifiedSubscriptionName)
    const addTheseItemsToSubscription = i18nTranslate(
      'cartCreateNewSubscriptionComponent.addToSubscription.addTheseItemsToSubscription_',
      'Add these items to %%subscription_name%%?',
      { isNextGenTranslations: true }
    ).replace('%%subscription_name%%', modifiedSubscriptionName)
    const selectSubscriptionTitle =
      itemCount === 1 ? addThisItemToSubscription : addTheseItemsToSubscription

    const addToSubscriptionTitle = i18nTranslate(
      'cartCreateNewSubscriptionComponent.addToSubscription.title',
      'Add to Subscription',
      { isNextGenTranslations: true }
    )

    const addItemToSubscriptionText = addToSubscriptionTitle

    return (
      <Modal
        onHide={handleAddToSubscriptionModalClose}
        show={showModal}
        className="add-subscription-modal-wrapper"
        data-testid="qa-add-to-subscription-modal">
        <Modal.Header
          closeButton
          className="add-subscription-modal-header"
          data-testid="qa-add-to-subscription-modal-header">
          <Modal.Title
            className="add-subscription-title"
            data-testid="qa-add-to-subscription-title">
            {addItemToSubscriptionText}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="add-subscription-modal-body"
          data-testid="qa-add-to-subscription-modal-body">
          <div className="add-subscription-wrapper">
            <p
              className="add-subscription-modal-title"
              data-testid="qa-add-item-to-subscription-title">
              {selectSubscriptionTitle}
            </p>
            <div className="subscription-details-wrapper">
              {this.renderSubscriptionProductDetails()}
            </div>
          </div>
          <div className="subscription-footer-wrapper">
            {this.renderAuthorizationLimitInfo()}
            {this.renderSubTotal()}
            {this.renderAgreementInfo()}
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export { AddToExistingSubscriptionModal }
export default AddToExistingSubscriptionModal
